import React from 'react';

import { Container, Flex, Logo } from '@coinflare/ui/core';

import { darkColors } from 'src/setup/theme/colors';

import { LoadingDots } from './styles';

export const LoadingPlaceholder = () => {
    return (
        <Container py={[4, 4, 16, 20]} background={darkColors.background.primary} height={'100vh'}>
            <Flex
                width={'100%'}
                height={'100%'}
                flexDirection={'column'}
                justifyContent="center"
                alignItems="center"
                gap={4}
            >
                <Logo theme={'dark'} />
                <LoadingDots />
            </Flex>
        </Container>
    );
};
